import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

const ChannelList = () => {
    const channels = useSelector((state) => state.channels);
    return (
        <Fragment>
            <div className="channel-list-header">
                {channels && channels.map((channel, index) => {
                    return (
                        <a key={`channel-${index}`} href={channel.url} title={channel.name} className="navbar__link">
                            <img src={channel.imageUrl} alt={channel.name}></img>
                        </a>
                    )
                })}
            </div>
        </Fragment>
    );
};

export default ChannelList;
